import cloneDeep from 'lodash/cloneDeep';

export default class Contact {
  id;
  firstName;
  lastName;
  avatar;
  email;
  phone1;
  modifiedBy;
  modifiedTime;
  notes = [];

  constructor(data) {
    Object.assign(this, cloneDeep(data));
  }

  /**
   * Returns name initials or displayName initials.
   *
   * @returns {String}
   */
  get initials() {
    let result = '';

    if (this.firstName) {
      result += this.firstName[0];
    }
    if (this.lastName) {
      result += this.lastName[0];
    }

    if (result.length < 2) {
      return Contact.getInitials(this.displayName);
    } else {
      return result.toUpperCase();
    }
  }

  get fullName() {
    return `${this.firstName || ''} ${this.lastName || ''}`.trim();
  }

  get displayName() {
    return this.fullName || this.email || this.phone1 || '';
  }

  get phones() {
    return getValuesFromPartialKey('phone', this);
  }

  get infoFields() {
    return getValuesFromPartialKey('text', this);
  }

  includes(searchString) {
    return this.displayName.toLowerCase().includes((searchString || '').toLowerCase());
  }

  static compare(contactA, contactB) {
    const comparableFieldsA = [
      contactA.fullName || String.fromCharCode(255),
      contactA.email || String.fromCharCode(255),
      contactA.phone1
    ]
      .join('')
      .toLowerCase();
    const comparableFieldsB = [
      contactB.fullName || String.fromCharCode(255),
      contactB.email || String.fromCharCode(255),
      contactB.phone1
    ]
      .join('')
      .toLowerCase();

    if (comparableFieldsA < comparableFieldsB) {
      return -1;
    }
    if (comparableFieldsA > comparableFieldsB) {
      return 1;
    }
    return 0;
  }

  static getInitials(name = '') {
    try {
      return name
        .match(/(^\S\S?|\b\S)?/g)
        .join('')
        .match(/(^\S|\S$)?/g)
        .join('')
        .toUpperCase();
    } catch {
      return '';
    }
  }
}

const getValuesFromPartialKey = (partialKey, baseObject) => {
  const values = [];

  for (const [key, value] of Object.entries(baseObject)) {
    if (key.startsWith(partialKey) && value) {
      values.push(value);
    }
  }

  return values;
};
